"use client";
import { createContext, useContext, ReactNode, useMemo } from "react";
import { WS, Config } from "./webSocket";

interface WSContextType {
  ws: WS | null;
  register: (topic: string, callback: EventListener) => void;
  unregister: () => void;
}

const WSContext = createContext<WSContextType | null>(null);

export const useWS = () => {
  const context = useContext(WSContext);
  if (!context) {
    throw new Error("useWS must be used within a WSProvider");
  }
  return context;
};

export const WSProvider = ({
  children,
  config,
}: {
  children: ReactNode;
  config: Config;
}) => {
  const ws = useMemo(() => new WS({ url: config?.url }), [config?.url]);
  try {
    const value = {
      ws,
      register: (topic: string, callback: EventListener) => {
        ws.register(topic, callback);
      },
      unregister: () => {
        ws.unregister();
      },
    };
    return <WSContext.Provider value={value}>{children}</WSContext.Provider>;
  } catch (error) {
    return <>{children}</>;
  }
};
